export const toggleToastState = (setFn: (value: boolean) => void) => {
  const timeout = setTimeout(() => {
    setFn(false);
  }, 5000);
  return () => clearTimeout(timeout); // Cleanup timeout
};
